// local backend server

// export const path = "https://api.feedants.com";

// export const path = "https://testants.azurewebsites.net";
// export const path = "http://localhost:8080";

// post sharing url
export const sharePostUrlPrefix = "https://www.feedants.com/#/"; // It is for Feedants
// export const sharePostUrlPrefix = "https://testants.azurewebsites.net/#"; // It is for testAnts

// production server don't use in it devlopment
export const path = "https://api.blaccsckull.com";
// our development and test server
// export const path = "https://backendbs.onrender.com"

export const ENV = path === "https://api.blaccsckull.com" ? "prod" : "dev"

export const RAZORPAY_KEY = ENV === "prod" ? "rzp_live_K4n0QIaK6k64oy" : "rzp_test_0afNUeK57l5gZi";
